import styles from "./Navbar.module.scss";
import { useContext } from "react";
import { AuthContext } from "../../services/Auth";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import { Link } from "react-router-dom";
import {
  Menu,
  //MenuItem,
  MenuButton,
  // SubMenu,
} from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
function InnerNavbar() {
  const { user } = useContext(AuthContext);

  if (!user) return "Carregando...";

  return (
    <>
      <Menu
        menuButton={
          <MenuButton className={styles.innerNavBtn}>
            Gerenciar <FontAwesomeIcon icon={faGear} />{" "}
          </MenuButton>
        }
        transition={false}
      >
        <div className={styles.innerNav}>
          <Link to="">Gerenciar usuários</Link>
          <Link to="classificados">Classificados</Link>
          <Link to="aprovados">Aprovados</Link>
          <Link to="validaDoc">Validação de documentação</Link>
        </div>
      </Menu>
    </>
  );
}

export default InnerNavbar;
